module.exports = __webpack_public_path__ + "img/logo.24f7d060.svg";